import { ReviewsContext } from "~/providers/ReviewsProvider";
import { useContext } from "react";

export const useReviewContext = () => {
  return useContext(ReviewsContext);
};
